import { render, staticRenderFns } from "./smallBall-photo.vue?vue&type=template&id=18862683&scoped=true&"
import script from "./smallBall-photo.vue?vue&type=script&lang=js&"
export * from "./smallBall-photo.vue?vue&type=script&lang=js&"
import style0 from "./smallBall-photo.vue?vue&type=style&index=0&id=18862683&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18862683",
  null
  
)

export default component.exports